export const FORM_URLS: Record<string, string> = {
  '联系我们': 'https://readdy.ai/api/form/d9qqfqfnahb7382ovdmg',
};

export function getFormUrl(formName: string): string {
  return FORM_URLS[formName] || '';
}